import { render } from "./AutocompletePage.vue?vue&type=template&id=316884a2&scoped=true"
import script from "./AutocompletePage.vue?vue&type=script&lang=js"
export * from "./AutocompletePage.vue?vue&type=script&lang=js"

import "./AutocompletePage.vue?vue&type=style&index=0&id=316884a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316884a2"]])

export default __exports__